import React from 'react';
import type {
  IndexInstrumentViewModel,
  IndicesCountryViewModel,
  IndicesMarketGroup,
  IndicesPeriod,
} from '@app-types/indices';
import IndicesCountrySection from './IndicesCountrySection';
import { buildIndicesLayoutRows } from './indicesLayout';

interface IndicesMarketLayoutProps {
  mktGroup: IndicesMarketGroup;
  countries: readonly IndicesCountryViewModel[];
  period: IndicesPeriod;
  onSelectInstrument: (instrument: IndexInstrumentViewModel, trigger: HTMLElement) => void;
}

const getCountryKey = (country: IndicesCountryViewModel, index: number): string => (
  `${country.country}:${country.instruments[0]?.id ?? 'empty'}:${index}`
);

const IndicesMarketLayout: React.FC<IndicesMarketLayoutProps> = ({
  mktGroup,
  countries,
  period,
  onSelectInstrument,
}) => {
  const rows = buildIndicesLayoutRows(countries, mktGroup);

  return (
    <div className="indices-market-layout">
      {rows.map((row, rowIndex) => {
        if (row.kind === 'country') {
          return (
            <div
              className="indices-market-layout__country-row"
              data-layout-row="country"
              key={`country-row:${getCountryKey(row.country, rowIndex)}`}
            >
              <IndicesCountrySection
                country={row.country}
                grid={row.grid}
                period={period}
                onSelectInstrument={onSelectInstrument}
              />
            </div>
          );
        }

        return (
          <div
            className="indices-market-layout__singleton-row"
            data-layout-row="singleton-group"
            key={`singleton-row:${row.countries.map(({ country }) => country).join(',')}:${rowIndex}`}
          >
            {row.countries.map((country, countryIndex) => (
              <IndicesCountrySection
                key={getCountryKey(country, countryIndex)}
                country={country}
                grid="singleton"
                period={period}
                onSelectInstrument={onSelectInstrument}
              />
            ))}
          </div>
        );
      })}
    </div>
  );
};

export default IndicesMarketLayout;
